module.exports = __webpack_public_path__ + "static/media/babylonjs.c52bd7a5.gif";